import brunello from "../config/brunello";
import swatch from "../config/swatch";
import swatchItaly from "../config/swatchItaly";
import swatchSwit from "../config/swatchSwit";
import bunnings from "../config/bunnings";
import bentleyUniversity from "../config/bentleyUniversity";
import demo from "../config/demo";

const useConfig = (company) => {
    const setFavicon = favicon => {
        document.querySelector("link[rel*='icon']").href = favicon;
    }

    if (window.location.hostname.toLowerCase() === "cucinelli.show") {
        setFavicon(brunello.favicon);
        brunello.customCss();
        return brunello;
    }

    switch (company) {
        case "brunello":
            setFavicon(brunello.favicon);
            brunello.customCss();
            return brunello;
        case "swatch":
            return swatch;
        case "swatch-italy":
            swatchItaly.customCss();
            return swatchItaly;
        case "swatch-switzerland":
            return swatchSwit;
        case "bunnings":
            bunnings.customCss();
            return bunnings;
        case "bentleyUniversity":
            return bentleyUniversity;
        case "demo":
            return demo;
        default:
            return null;
    }

}

export default useConfig;